<template>
  <div class="three-dimension-container">
    <div id="container"></div>
    
    <div class="title">二白机器人 · 数字生命体领养中心</div>
    
    <div class="controls" :class="{ 'collapsed': isControlsCollapsed }">
      <h2>调试窗口</h2>
      <div class="toggle-controls" @click="toggleControls">
        <div class="hamburger">
          <div class="bar"></div>
        </div>
      </div>
      <div class="control-group">
        <label for="rotationSpeed">旋转速度</label>
        <input type="range" id="rotationSpeed" v-model="rotationSpeed" min="0" max="1" step="0.05" @input="updateRotationSpeed">
        <div class="value-display">当前速度: <span id="speedValue">{{ rotationSpeed.toFixed(2) }}</span></div>
      </div>
      <div class="control-group">
        <label for="particleSize">粒子大小</label>
        <input type="range" id="particleSize" v-model="particleSize" min="0.1" max="2" step="0.1" @input="updateParticleSize">
        <div class="value-display">当前大小: <span id="sizeValue">{{ particleSize.toFixed(1) }}</span></div>
      </div>
      <div class="control-group">
        <label for="particleCount">粒子数量</label>
        <input type="range" id="particleCount" v-model="particleCount" min="5" max="2000" step="10" @input="updateParticleCount">
        <div class="value-display">当前数量: <span id="countValue">{{ particleCount }}</span></div>
      </div>
      <div class="control-group">
        <label for="distanceFactor">分布范围</label>
        <input type="range" id="distanceFactor" v-model="distanceFactor" min="1" max="30" step="1" @input="updateDistanceFactor">
        <div class="value-display">当前范围: <span id="distValue">{{ distanceFactor }}</span></div>
      </div>
      <div class="control-group">
        <label for="cameraDistance">观测距离</label>
        <input type="range" id="cameraDistance" v-model="cameraDistance" min="10" max="80" step="1" @input="updateCameraDistance">
        <div class="value-display">当前距离: <span id="cameraValue">{{ cameraDistance }}</span></div>
      </div>
      <div class="control-group">
        <label for="textThreshold">标签显示数量</label>
        <input type="range" id="textThreshold" v-model="textThreshold" min="0" max="50" step="1" @input="updateTextThreshold">
        <div class="value-display">显示数量: <span id="textThresholdValue">{{ textThreshold }}</span></div>
      </div>
      <button class="btn1" @click="handleButtonClick(1)">开屏动画</button>
      <button class="btn1" @click="handleButtonClick(2)">真实加载</button>
      <select class="select-menu" v-model="selectedPersonality" @change="handlePersonalityChange">
        <option value="1">小干部</option>
        <option value="2">佛系</option>
        <option value="3">脑洞大</option>
        <option value="4">爱出点子</option>
        <option value="5">社交悍匪</option>
        <option value="6">乖巧</option>
        <option value="7">活泼</option>
        <option value="8">粘人</option>
        <option value="9">情绪稳定</option>
        <option value="10">乐天派</option>
        <option value="11">热心肠</option>
        <option value="12">脑路新奇</option>
      </select>
      <button class="btn1" @click="handleButtonClick(3)">选词减生命体</button>
      <button class="btn1" @click="handleButtonClick(4)">去词加生命体</button>
      <button id="resetBtn" class="btn" @click="resetGalaxy">创建/重置星系</button>
    </div>
    
    <div class="info" id="info">等待选择<div id="keywords"></div></div>
    
    <div class="date-button-container" :class="{ 'collapsed': isDateContainerCollapsed }">
      <button class="toggle-btn" @click="toggleDateContainer">{{ isDateContainerCollapsed ? '展开' : '收起' }}</button>
      <div v-if="!isDateContainerCollapsed">
        <div>当前星座：{{ currentZodiac }}</div>
        <br>
        <input type="date" id="datePicker" class="date-picker" v-model="selectedDate" @change="handleDateChange">
        <div class="button-grid">
          <button 
            v-for="(keyword, index) in keywords" 
            :key="index"
            class="keyword-btn" 
            :class="{ 'selected': selectedKeywords.includes(keyword) }"
            @click="toggleKeyword(keyword)"
            :disabled="isKeywordDisabled(keyword)"
          >
            {{ keyword }}
          </button>
        </div>
        <br>
        <button id="selectLifeForm" class="btn1" :disabled="selectedKeywords.length === 0" @click="selectLifeForm">选择当前生命体</button>
      </div>
    </div>
    
    <div id="codeModal" class="modal-container" v-if="showCodeModal">
      <div class="modal-content modal-content-container">
        <b>生命体密钥</b>
        <br>
        <div style="font-size: 0.8em;">请在小程序种填写密钥</div>
        <div style="font-size: 0.8em;">锁定该生命体</div>
        <br>
        <div class="code-display">
          <div v-for="(digit, index) in codeDigits" :key="index" class="code-digit">{{ digit }}</div>
        </div>
        <div class="modal-buttons">
          <button class="btn1" @click="copyCode">复制</button>
          <button class="btn1" @click="closeCodeModal">关闭</button>
        </div>
      </div>
    </div>
    
    <div id="infoModal" class="modal-container" v-if="showInfoModal">
      <div class="modal-content modal-content-container" id="modalContent" style="max-width:300px; min-height:200px; max-height:70vh;">
        <div class="scroll-content" style="overflow-y:auto; padding-right:10px; flex-grow:1;">
          <h3 style="color:#4ecca3; margin-bottom:15px;">领养说明</h3>
          <p style="text-align:left; line-height:2; margin-bottom:25px; font-size: small;" v-html="infoModalContent"></p>
        </div>
        <div class="modal-buttons" style="margin-top:20px; padding-bottom:15px; width:100%; display:flex; justify-content:flex-end;">
          <button class="btn1" @click="closeInfoModal">关闭</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as THREE from 'three'
import TWEEN from '@tweenjs/tween.js'

export default {
  name: 'ThreeDimensionalPersonality',
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      labelRenderer: null,
      particlesGroup: null,
      celestialGroup: null,
      rings: [],
      glowMeshes: [],
      centerGlow: null,
      lightGroup: null,
      labelCache: {},
      visibleLabels: [],
      maxVisibleLabels: 10,
      clock: null,
      
      rotationSpeed: 1.0,
      particleSize: 0.3,
      particleCount: 100,
      distanceFactor: 15,
      cameraDistance: 30,
      textThreshold: 10,
      
      isControlsCollapsed: false,
      isDateContainerCollapsed: false,
      selectedDate: '',
      currentZodiac: '',
      selectedKeywords: [],
      keywords: ['小干部', '佛系', '脑洞大', '爱出点子', '社交悍匪', '乖巧', '活泼', '粘人', '情绪稳定', '乐天派', '热心肠', '脑路新奇'],
      selectedPersonality: '1',
      
      showCodeModal: false,
      codeDigits: [],
      showInfoModal: false,
      infoModalContent: '',
      
      zodiacMap: {
        '白羊座': ['乐天派'],
        '金牛座': ['情绪稳定'],
        '双子座': ['脑路新奇'],
        '巨蟹座': ['热心肠'],
        '狮子座': ['乐天派'],
        '处女座': ['情绪稳定'],
        '天秤座': ['热心肠'],
        '天蝎座': ['脑路新奇'],
        '射手座': ['乐天派'],
        '摩羯座': ['情绪稳定'],
        '水瓶座': ['脑路新奇'],
        '双鱼座': ['热心肠']
      },
      
      exclusiveGroups: [['小干部', '佛系'], ['社交悍匪', '乖巧']]
    }
  },
  mounted() {
    this.init()
    this.setupDatePicker()
  },
  beforeDestroy() {
    this.cleanup()
  },
  methods: {
    init() {
      const container = document.getElementById('container')
      
      this.scene = new THREE.Scene()
      this.clock = new THREE.Clock()
      
      this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000)
      this.camera.position.z = 30
      
      this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
      this.renderer.setSize(window.innerWidth, window.innerHeight)
      this.renderer.setPixelRatio(window.devicePixelRatio)
      container.appendChild(this.renderer.domElement)
      
      this.createParticles()
      this.createCelestialBody()
      this.createRings()
      this.createLights()
      
      window.addEventListener('resize', this.onWindowResize)
      
      this.animate()
    },
    
    createParticles() {
      this.particlesGroup = new THREE.Group()
      
      const geometry = new THREE.SphereGeometry(1, 32, 32)
      const material = new THREE.MeshBasicMaterial({
        color: 0x4ecca3,
        transparent: true,
        opacity: 0.8
      })
      
      for (let i = 0; i < this.particleCount; i++) {
        const particle = new THREE.Mesh(geometry, material.clone())
        
        const theta = Math.random() * Math.PI * 2
        const phi = Math.acos(2 * Math.random() - 1)
        const distance = 5 + Math.random() * this.distanceFactor
        
        particle.position.x = distance * Math.sin(phi) * Math.cos(theta)
        particle.position.y = distance * Math.sin(phi) * Math.sin(theta)
        particle.position.z = distance * Math.cos(phi)
        
        particle.scale.set(this.particleSize, this.particleSize, this.particleSize)
        
        particle.userData = {
          id: i,
          baseSpeed: 0.5 + Math.random() * 0.5,
          originalPosition: particle.position.clone(),
          distance: distance
        }
        
        this.particlesGroup.add(particle)
      }
      
      this.scene.add(this.particlesGroup)
    },
    
    createCelestialBody() {
      this.celestialGroup = new THREE.Group()
      
      const geometry = new THREE.SphereGeometry(3, 64, 64)
      const material = new THREE.MeshBasicMaterial({
        color: 0x4ecca3,
        transparent: true,
        opacity: 0.3
      })
      
      const celestialBody = new THREE.Mesh(geometry, material)
      this.celestialGroup.add(celestialBody)
      
      const glowGeometry = new THREE.SphereGeometry(3.5, 64, 64)
      const glowMaterial = new THREE.MeshBasicMaterial({
        color: 0x4ecca3,
        transparent: true,
        opacity: 0.1
      })
      
      this.centerGlow = new THREE.Mesh(glowGeometry, glowMaterial)
      this.celestialGroup.add(this.centerGlow)
      
      this.scene.add(this.celestialGroup)
    },
    
    createRings() {
      const ringConfigs = [
        { radius: 6, color: 0x4ecca3, opacity: 0.3, speed: 0.5 },
        { radius: 9, color: 0x41a88d, opacity: 0.2, speed: 0.3 },
        { radius: 12, color: 0x4fc6eb, opacity: 0.15, speed: 0.2 }
      ]
      
      ringConfigs.forEach((config, index) => {
        const geometry = new THREE.RingGeometry(config.radius - 0.1, config.radius + 0.1, 64)
        const material = new THREE.MeshBasicMaterial({
          color: config.color,
          transparent: true,
          opacity: config.opacity,
          side: THREE.DoubleSide
        })
        
        const ring = new THREE.Mesh(geometry, material)
        ring.rotation.x = Math.PI / 2
        ring.userData = { speed: config.speed }
        
        this.rings.push(ring)
        this.scene.add(ring)
      })
    },
    
    createLights() {
      this.lightGroup = new THREE.Group()
      
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
      this.lightGroup.add(ambientLight)
      
      const pointLight = new THREE.PointLight(0x4ecca3, 1, 100)
      pointLight.position.set(0, 0, 0)
      this.lightGroup.add(pointLight)
      
      this.scene.add(this.lightGroup)
    },
    
    animate() {
      requestAnimationFrame(this.animate)
      
      TWEEN.update()
      
      const elapsedTime = this.clock.getElapsedTime()
      
      this.particlesGroup.children.forEach(particle => {
        const speed = particle.userData.baseSpeed * this.rotationSpeed
        const originalPosition = particle.userData.originalPosition || particle.position.clone()
        
        const newX = originalPosition.x * Math.cos(speed * elapsedTime) - originalPosition.z * Math.sin(speed * elapsedTime)
        const newZ = originalPosition.x * Math.sin(speed * elapsedTime) + originalPosition.z * Math.cos(speed * elapsedTime)
        
        particle.position.set(newX, particle.position.y, newZ)
      })
      
      const pulse = 1 + Math.sin(elapsedTime * 2) * 0.1
      this.celestialGroup.scale.set(pulse, pulse, pulse)
      this.centerGlow.scale.set(2 * pulse, 2 * pulse, 1)
      
      this.rings.forEach((ring, index) => {
        const ringSpeed = ring.userData.speed
        const ringPulse = 1 + Math.sin(elapsedTime * 3 + ringSpeed) * 0.1
        ring.scale.set(ringPulse, ringPulse, 1)
      })
      
      this.renderer.render(this.scene, this.camera)
    },
    
    onWindowResize() {
      this.camera.aspect = window.innerWidth / window.innerHeight
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(window.innerWidth, window.innerHeight)
    },
    
    cleanup() {
      window.removeEventListener('resize', this.onWindowResize)
      
      if (this.renderer) {
        this.renderer.dispose()
      }
      
      Object.keys(this.labelCache).forEach(key => {
        const { label } = this.labelCache[key]
        this.scene.remove(label)
        delete this.labelCache[key]
      })
    },
    
    toggleControls() {
      this.isControlsCollapsed = !this.isControlsCollapsed
    },
    
    toggleDateContainer() {
      this.isDateContainerCollapsed = !this.isDateContainerCollapsed
    },
    
    setupDatePicker() {
      const today = new Date()
      const minDate = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate())
      const maxDate = new Date(today)
      
      this.selectedDate = maxDate.toISOString().split('T')[0]
      
      this.handleDateChange()
    },
    
    handleDateChange() {
      const date = new Date(this.selectedDate)
      this.currentZodiac = this.getZodiac(date)
      this.updateZodiacButtons(date)
    },
    
    getZodiac(date) {
      const month = date.getMonth() + 1
      const day = date.getDate()
      
      if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return '白羊座'
      if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return '金牛座'
      if ((month === 5 && day >= 21) || (month === 6 && day <= 21)) return '双子座'
      if ((month === 6 && day >= 22) || (month === 7 && day <= 22)) return '巨蟹座'
      if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return '狮子座'
      if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return '处女座'
      if ((month === 9 && day >= 23) || (month === 10 && day <= 23)) return '天秤座'
      if ((month === 10 && day >= 24) || (month === 11 && day <= 22)) return '天蝎座'
      if ((month === 11 && day >= 23) || (month === 12 && day <= 21)) return '射手座'
      if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return '摩羯座'
      if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return '水瓶座'
      if ((month === 2 && day >= 19) || (month === 3 && day <= 20)) return '双鱼座'
      
      return '未知'
    },
    
    updateZodiacButtons(date) {
      const zodiac = this.getZodiac(date)
      const zodiacKeywords = this.zodiacMap[zodiac] || []
      
      this.keywords.forEach(keyword => {
        if (zodiacKeywords.includes(keyword)) {
          if (!this.selectedKeywords.includes(keyword)) {
            this.selectedKeywords.push(keyword)
          }
        }
      })
    },
    
    isKeywordDisabled(keyword) {
      for (const group of this.exclusiveGroups) {
        if (group.includes(keyword)) {
          const selectedInGroup = group.filter(k => this.selectedKeywords.includes(k))
          if (selectedInGroup.length > 0 && !selectedInGroup.includes(keyword)) {
            return true
          }
        }
      }
      return false
    },
    
    toggleKeyword(keyword) {
      if (this.selectedKeywords.includes(keyword)) {
        this.selectedKeywords = this.selectedKeywords.filter(k => k !== keyword)
      } else {
        if (this.isKeywordDisabled(keyword)) {
          for (const group of this.exclusiveGroups) {
            if (group.includes(keyword)) {
              this.selectedKeywords = this.selectedKeywords.filter(k => !group.includes(k))
            }
          }
        }
        this.selectedKeywords.push(keyword)
      }
    },
    
    selectLifeForm() {
      const code = this.generateCode()
      this.codeDigits = code.split('')
      this.showCodeModal = true
    },
    
    generateCode() {
      let code = ''
      for (let i = 0; i < 6; i++) {
        code += Math.floor(Math.random() * 10)
      }
      return code
    },
    
    copyCode() {
      const code = this.codeDigits.join('')
      navigator.clipboard.writeText(code)
    },
    
    closeCodeModal() {
      this.showCodeModal = false
    },
    
    closeInfoModal() {
      this.showInfoModal = false
    },
    
    updateRotationSpeed() {
      
    },
    
    updateParticleSize() {
      this.particlesGroup.children.forEach(particle => {
        particle.scale.set(this.particleSize, this.particleSize, this.particleSize)
      })
    },
    
    updateParticleCount() {
      const currentCount = this.particlesGroup.children.length
      const newCount = this.particleCount
      
      if (newCount > currentCount) {
        for (let i = currentCount; i < newCount; i++) {
          const geometry = new THREE.SphereGeometry(1, 32, 32)
          const material = new THREE.MeshBasicMaterial({
            color: 0x4ecca3,
            transparent: true,
            opacity: 0.8
          })
          
          const particle = new THREE.Mesh(geometry, material)
          
          const theta = Math.random() * Math.PI * 2
          const phi = Math.acos(2 * Math.random() - 1)
          const distance = 5 + Math.random() * this.distanceFactor
          
          particle.position.x = distance * Math.sin(phi) * Math.cos(theta)
          particle.position.y = distance * Math.sin(phi) * Math.sin(theta)
          particle.position.z = distance * Math.cos(phi)
          
          particle.scale.set(this.particleSize, this.particleSize, this.particleSize)
          
          particle.userData = {
            id: i,
            baseSpeed: 0.5 + Math.random() * 0.5,
            originalPosition: particle.position.clone(),
            distance: distance
          }
          
          this.particlesGroup.add(particle)
        }
      } else if (newCount < currentCount) {
        const particlesToRemove = currentCount - newCount
        for (let i = 0; i < particlesToRemove; i++) {
          const particle = this.particlesGroup.children[this.particlesGroup.children.length - 1]
          this.particlesGroup.remove(particle)
          particle.geometry.dispose()
          particle.material.dispose()
        }
      }
      
      this.maxVisibleLabels = Math.min(this.particlesGroup.children.length, this.textThreshold)
    },
    
    updateDistanceFactor() {
      this.particlesGroup.children.forEach(particle => {
        let distanceFactor
        if (particle.userData.distanceFactor === undefined) {
          distanceFactor = 1 + Math.random() * this.distanceFactor
          particle.userData.distanceFactor = distanceFactor
        } else {
          distanceFactor = particle.userData.distanceFactor
        }
        
        const newPosition = particle.userData.originalPosition.clone().normalize().multiplyScalar(distanceFactor)
        particle.userData.originalPosition = newPosition
        particle.userData.distance = distanceFactor
      })
    },
    
    updateCameraDistance() {
      this.camera.position.z = this.cameraDistance
    },
    
    updateTextThreshold() {
      this.maxVisibleLabels = Math.min(this.particlesGroup.children.length, this.textThreshold)
    },
    
    handleButtonClick(buttonId) {
      switch (buttonId) {
        case 1:
          this.playOpeningAnimation()
          break
        case 2:
          this.realLoad()
          break
        case 3:
          this.removeLifeForm()
          break
        case 4:
          this.addLifeForm()
          break
      }
    },
    
    playOpeningAnimation() {
      this.infoModalContent = '正在播放开屏动画...'
      this.showInfoModal = true
    },
    
    realLoad() {
      this.infoModalContent = '正在真实加载...'
      this.showInfoModal = true
    },
    
    removeLifeForm() {
      if (this.particleCount > 5) {
        this.particleCount -= 10
        this.updateParticleCount()
      }
    },
    
    addLifeForm() {
      if (this.particleCount < 2000) {
        this.particleCount += 10
        this.updateParticleCount()
      }
    },
    
    resetGalaxy() {
      this.cleanup()
      this.init()
    },
    
    handlePersonalityChange() {
      
    }
  }
}
</script>

<style lang="scss" scoped>
.three-dimension-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  margin: 0;
  overflow: hidden;
  background:
    radial-gradient(ellipse at 10% 20%, rgba(30, 58, 138, 0.3) 0%, transparent 30%),
    radial-gradient(ellipse at 90% 80%, rgba(129, 52, 175, 0.2) 0%, transparent 30%),
    radial-gradient(ellipse at 50% 30%, rgba(0, 200, 200, 0.2) 0%, transparent 50%),
    linear-gradient(135deg, rgba(8, 12, 48, 1) 0%, rgba(4, 7, 30, 1) 50%, rgba(2, 4, 20, 1) 100%);
  font-family: 'Arial', sans-serif;
  color: #fff;
}

#container {
  position: relative;
  width: 100%;
  height: 100%;
}

.controls {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(0, 0, 0, 0.7);
  padding: 15px;
  border-radius: 10px;
  z-index: 1000;
  min-width: 300px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 20px rgba(78, 204, 163, 0.3);
  transition: all 0.3s ease;
  overflow: hidden;

  &.collapsed {
    height: 30px !important;
    padding: 0;

    > *:not(.toggle-controls) {
      opacity: 0;
      pointer-events: none;
    }
  }
}

.controls h2 {
  margin-top: 0;
  margin-bottom: 15px;
  color: #4ecca3;
  font-size: 1.5rem;
  text-shadow: 0 0 10px rgba(78, 204, 163, 0.9);
  text-align: center;
}

.control-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
  font-size: 0.9rem;
  color: #e0e0ff;
}

input[type="range"] {
  width: 100%;
  margin-bottom: 5px;
  background: rgba(100, 150, 255, 0.1);
  border-radius: 5px;
  height: 5px;
  -webkit-appearance: none;
}

input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #4ecca3;
  cursor: pointer;
  box-shadow: 0 0 8px rgba(78, 204, 163, 0.8);
}

.value-display {
  font-size: 0.8rem;
  color: #aaa;
  margin-top: 5px;
}

.btn {
  display: block;
  width: 100%;
  background: linear-gradient(45deg, #4ecca3, #41a88d);
  border: none;
  color: white;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  transition: all 0.3s;
  box-shadow: 0 0 12px rgba(78, 204, 163, 0.7);
  margin-top: 10px;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 0 20px rgba(78, 204, 163, 0.9);
  }
}

.btn1,
.select-menu {
  display: block;
  width: 100%;
  background: linear-gradient(45deg, #4fc6eb, #4668d8);
  border: none;
  color: white;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  font-size: 1rem;
  transition: all 0.3s;
  box-shadow: 0 0 12px rgba(78, 204, 163, 0.7);
  margin-top: 10px;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 0 20px rgba(78, 204, 163, 0.9);
  }
}

.select-menu {
  background: linear-gradient(45deg, #ff9891, #ff59d6);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 8px 35px 8px 15px;
  font-size: 1rem;
  color: white;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%234ecca3'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 12px;
}

.btn1:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background: #4488e0;
}

.info {
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  padding: 10px 20px;
  border-radius: 20px;
  font-size: 0.9rem;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 15px rgba(78, 204, 163, 0.2);
  text-align: center;
  font-weight: bold;
  color: #e0e0ff;
  z-index: 1000;
}

.title {
  position: absolute;
  top: 20px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  font-weight: bold;
  text-shadow: 0 0 20px rgba(78, 204, 163, 0.9);
  color: white;
  z-index: 1000;
}

.date-button-container {
  position: absolute;
  bottom: 90px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 10px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 15px rgba(78, 204, 163, 0.2);
  text-align: center;
  z-index: 1000;
  transition: all 0.3s ease;
  overflow: hidden;

  &.collapsed {
    width: 64px;
    height: 26px;
    padding: 8px;
  }
}

.toggle-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 70px;
  height: 30px;
  border-radius: 10%;
  background: #2f3a52;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 15px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 8px rgba(78, 204, 163, 0.5);
}

.date-picker {
  background: rgba(100, 150, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  padding: 8px;
  margin-bottom: 15px;
  width: 200px;
  text-align: center;
  font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
  cursor: pointer;
  position: relative;
  font-size: 20px;

  &::-webkit-calendar-picker-indicator {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    color: transparent;
    background: transparent;
  }

  &::-webkit-datetime-edit {
    font-family: 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-calendar-picker-indicator {
    filter: invert(1);
  }
}

.button-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.keyword-btn {
  border: none;
  color: white;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  width: 72px;
  background: linear-gradient(45deg, #1E90FF, #1C86EE);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 0 10px rgba(78, 204, 163, 0.7);
  }

  &.selected {
    background: linear-gradient(45deg, #ff59d6, #ff9891);
    box-shadow: 0 0 15px rgba(255, 89, 214, 0.7);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content-container {
  position: relative;
  background: rgba(0, 0, 0, 0.7);
  padding: 20px;
  border-radius: 10px;
  backdrop-filter: blur(5px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 0 15px rgba(78, 204, 163, 0.2);
  text-align: center;
  z-index: 1000;
}

.code-display {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.scroll-content::-webkit-scrollbar {
  width: 8px;
}

.scroll-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

.scroll-content::-webkit-scrollbar-thumb {
  background: #4ecca3;
  border-radius: 4px;
}

.code-digit {
  width: 40px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
}

.modal-buttons {
  display: flex;
  gap: 15px;
  padding: 8px 0;
}

.toggle-controls {
  position: absolute;
  top: -30px;
  left: 0;
  width: 100%;
  height: 30px;
  cursor: pointer;
  z-index: 101;
}

.hamburger {
  width: 25px;
  height: 20px;
  position: relative;
  margin: 0 auto;
  transition: transform 0.3s ease-in-out;
}

.hamburger .bar {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 2px;
  background: #4ecca3;
  transition: all 0.3s;
  opacity: 0.5;
}

.controls.collapsed .bar:nth-child(1) {
  opacity: 1;
}

@media (max-width: 768px) {
  .controls {
    width: calc(100% - 40px);
    max-width: none;
    top: 70px;
    left: 20px;
    right: 20px;
  }

  .title {
    font-size: 1.5rem;
    top: 15px;
  }

  .info {
    text-align: center;
    font-size: 0.8rem;
  }
}
</style>
